export default __webpack_public_path__ + "ce337d8dab40fa7325646d29295c1c97.png";